import $ from 'jquery';
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker';

class Daterange {
  #daterangeInput;

  constructor(daterangeInput) {
    this.#daterangeInput = daterangeInput;
  }

  init() {
    $(this.#daterangeInput).daterangepicker({
      showDropdowns: true,
      autoApply: true,
      ranges: {
          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 days': [moment().subtract(6, 'days'), moment().subtract(1, 'days')],
          'Last 30 days': [moment().subtract(29, 'days'), moment().subtract(1, 'days')],
          'This month': [moment().startOf('month'), moment().subtract(1, 'days')],
          'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      minDate: moment('2024-01-01'),
      maxDate: moment().subtract(1, 'days'),
      locale: {
          format: 'DD.MM.YYYY',
          separator: ' - ',
          applyLabel: 'Ok',
          cancelLabel: 'Cancel',
          fromLabel: 'From',
          toLabel: 'To',
          customRangeLabel: 'Customised.',
          weekLabel: 'W',
          daysOfWeek: [
              'Su',
              'Mo',
              'Tu',
              'We',
              'Th',
              'Fr',
              'Sa'
          ],
          monthNames: [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December'
          ],
          firstDay: 1
      },
      startDate: typeof this.#daterangeInput.dataset.daterangeStart !== 'undefined' ? moment(this.#daterangeInput.dataset.daterangeStart) : moment().subtract(28, 'days'),
      endDate: typeof this.#daterangeInput.dataset.daterangeEnd !== 'undefined' ? moment(this.#daterangeInput.dataset.daterangeEnd) : moment(),
      drops: 'auto'
    }, (start, end) => {
      if (typeof this.#daterangeInput.dataset.daterangeStartHidden !== 'undefined') {
        const startDateHidden = document.querySelector(this.#daterangeInput.dataset.daterangeStartHidden);

        if (startDateHidden !== null) {
          startDateHidden.value = start.format('YYYY-MM-DD');
        }
      }

      if (typeof this.#daterangeInput.dataset.daterangeEndHidden !== 'undefined') {
        const endDateHidden = document.querySelector(this.#daterangeInput.dataset.daterangeEndHidden);

        if (endDateHidden !== null) {
          endDateHidden.value = end.format('YYYY-MM-DD');
        }
      }
    });
  }
}

export default Daterange;
